import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import {
  themes,
  scrollTop,
  StatusType,
  tableRowSize,
  stickyHeader,
} from "services/constants";
import { useSelector } from "react-redux";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import {
  operationsDailyPayrunHeader,
  dailyPayrunHeaders,
  dailyPayrunColors,
} from "pages/PayRoll/PayRollHeaders";
import { Typography, Box, Paper } from "@mui/material";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
export const DailyPayRun = () => {
  const { domain, userScreenAccess, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dailyPayRunDetails, setDailyPayrunDetails] = useState([]);
  const containerRef = useRef(null);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Payroll Processing",
    "Daily Payrun"
  );
  const {
    result: dailyPayRunData,
    loading,
    setLoad: reCallApi,
  } = useFetch(
    `${domain}payroll/daily_earning_details/?company_id=${topbarCompanyId}`
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);
  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setDailyPayrunDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage]
  );

  useEffect(() => {
    if (topbarCompanyId) {
      reCallApi(true);
    }
  }, [reCallApi, topbarCompanyId]);

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
            Daily Pay Run
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Review and finalize employee payments for the day.
          </Typography>
        </Box>
        <Paper sx={{ width: "100%", height: "78vh" }}>
          <CustomFilter
            title="Daily Pay Run Records"
            filterHeaders={operationsDailyPayrunHeader}
            data={dailyPayRunData}
            filteredData={dailyPayRunDetails}
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={check_access}
          />
          <Mui.Grid sx={{ ml: 2, mr: 2 }}>
            <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
              <Mui.Table className="border">
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {dailyPayrunHeaders.map((header) => (
                      <Mui.TableCell
                        key={header.name}
                        align="center"
                        colSpan={header.children ? header.children.length : 1}
                        rowSpan={header.children ? 1 : 2}
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                          border: "1px solid #ddd",
                        }}
                      >
                        {header.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                  <Mui.TableRow sx={tableRowSize}>
                    {dailyPayrunHeaders
                      .filter((header) => header.children)
                      .flatMap((header) =>
                        header.children.map((child) => (
                          <Mui.TableCell
                            key={child.key}
                            align="center"
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                              border: "1px solid #ddd",
                            }}
                          >
                            {child.name}
                          </Mui.TableCell>
                        ))
                      )}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {dailyPayRunDetails?.length === 0 ? (
                    <InfoMessage dataLength={dailyPayRunData} />
                  ) : (
                    dailyPayRunDetails
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row) => (
                        <Mui.TableRow sx={tableRowSize}>
                          {dailyPayrunHeaders.flatMap((header) =>
                            header.children
                              ? header.children.map((child) => (
                                  <Mui.TableCell
                                    key={child.key}
                                    align="center"
                                    sx={{ border: "1px solid #ddd" }}
                                  >
                                    {row[child.key] ?? "-"}
                                  </Mui.TableCell>
                                ))
                              : [
                                  <Mui.TableCell
                                    key={header.key}
                                    align="center"
                                    sx={{ border: "1px solid #ddd" }}
                                  >
                                    {header.key === "day_type" ? (
                                      <span
                                        style={StatusType(
                                          row.day_type,
                                          dailyPayrunColors
                                        )}
                                      >
                                        {row.day_type}
                                      </span>
                                    ) : (
                                      row[header.key] ?? "-"
                                    )}
                                  </Mui.TableCell>,
                                ]
                          )}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
            <Box sx={{ mt: 1 }}>
              {dailyPayRunDetails?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={dailyPayRunDetails?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Box>
          </Mui.Grid>
        </Paper>
      </Box>
    </React.Fragment>
  );
};
